/* eslint-disable max-lines-per-function */
import ResizeObserver from 'resize-observer-polyfill';
import { computed, onMounted, watch, onBeforeUnmount, nextTick } from 'vue-demi';
import { TAB_TYPE } from '../constant';
const { isPreRender } = require('../util');

export function useHeaderBar({ horizontalTabRef, props }) {
    let activeItemObserver = null;

    const isLineMode = computed(() => {
        return props.tpl.props.tabType === TAB_TYPE.LINE;
    });

    const resetHeaderBar = () => {
        // 圆形模式，不需要展示下划线
        if (!isLineMode.value) {
            return;
        }
        nextTick(() => {
            const activeElm = horizontalTabRef.value?.querySelector('.horizontal-anchor-tab-part.active');
            const barElm = horizontalTabRef.value?.querySelector('.horizontal-anchor-tab-header-active-bar');
            const boxElm = horizontalTabRef.value?.querySelector('.horizontal-anchor-tab-header-real');
            if (activeElm && barElm) {
                const { left, width } = activeElm.getBoundingClientRect();
                const { left: parentLeft } = activeElm.parentElement.getBoundingClientRect();
                barElm.style.width = width + 'px';
                barElm.style.transform = `translateX(${left - parentLeft + boxElm.scrollLeft }px)`;
            }
        });
    };

    const resetHeaderLongBar = () => {
        // 圆形模式，不需要展示下划线
        if (!isLineMode.value) {
            return;
        }
        nextTick(() => {
            const boxElm = horizontalTabRef.value?.querySelector('.horizontal-anchor-tab-header-real');
            const longBarElm = horizontalTabRef.value?.querySelector('.horizontal-anchor-tab-header-long-bar');
            if (boxElm && longBarElm) {
                longBarElm.style.width = boxElm.scrollWidth + 'px';
            }
        });
    };

    const observeActiveItem = () => {
        // 圆形模式，不需要展示下划线
        if (!isLineMode.value) {
            return;
        }
        const element = horizontalTabRef.value?.querySelector('.horizontal-anchor-tab-part.active');
        activeItemObserver = new ResizeObserver((entries) => {
            resetHeaderBar();
            resetHeaderLongBar();
        });

        if (element) {
            activeItemObserver?.observe(element);
        }
    };

    const unobserveActiveItem = () => {
        activeItemObserver?.disconnect();
    };

    // 切换 - 间距、高度、对齐方式、字号等
    watch(
        () => props.tpl,
        () => {
            resetHeaderBar();
        },
        {
            deep: true
        }
    );

    // 处理特殊情况 - 手动触发切换圆形/线段
    watch(
        () => props.tpl.props.tabType,
        (newVal, oldVal) => {
            if (newVal === TAB_TYPE.CIRCLE) {
                unobserveActiveItem();
            } else {
                observeActiveItem();
                resetHeaderBar();
            }
        }
    );

    onMounted(() => {
        if (isPreRender()) {
            return;
        }
        resetHeaderBar();
        resetHeaderLongBar();
        observeActiveItem();
    });

    onBeforeUnmount(() => {
        unobserveActiveItem();
    });

    return {
        isLineMode,
        resetHeaderBar
    };
}
